import { useState, useEffect } from "react";
import { fetchContractCategories } from "../services/contractCategoriesService";

const FALLBACK: readonly string[] = ["NDA", "MSA", "SOW"];

export const useContractCategories = () => {
  const [categories, setCategories] = useState<readonly string[]>(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchContractCategories()
      .then((data) => {
        if (!cancelled && data.length > 0) setCategories(data);
      })
      .catch(() => {
        /* keep fallback */
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, loading };
};
